var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var OrgInfo_1;
import './orgFeatureFlag'; // force import for JsonSchema
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { OrgPlan } from '@symon-ai/wisepipe-user';
import { OrgTypes } from '@symon-ai/wisepipe-common';
export var IDP_NAME;
(function (IDP_NAME) {
    IDP_NAME["COGNITO_IDP_NAME"] = "Cognito";
    IDP_NAME["GOOGLE_IDP_NAME"] = "Google";
    IDP_NAME["FACEBOOK_IDP_NAME"] = "Facebook";
    IDP_NAME["SAML_IDP_NAME"] = "SAML";
})(IDP_NAME || (IDP_NAME = {}));
const schema = {
    $id: 'urn:wisepipe-domain-authorize:OrgInfo',
    type: 'object',
    properties: {
        id: { type: 'string', format: 'uuid' },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        orgPlan: {
            type: 'string',
            enum: Object.values(OrgPlan)
        },
        initialCredit: { type: 'number', minimum: 0 },
        seats: { type: 'number', minimum: 0 },
        createdAt: { type: 'string', format: 'date-time' },
        supportedLoginTypes: { type: 'array', items: { type: 'string' } },
        featureFlags: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:OrgFeatureFlag' } },
        salesforceAcctId: { type: 'string' },
        orgType: { type: 'string', enum: Object.values(OrgTypes) },
        orgTimezone: { type: 'string', minLength: 1 }
    },
    required: ['id', 'name', 'orgPlan', 'initialCredit', 'seats']
};
let OrgInfo = OrgInfo_1 = class OrgInfo {
    constructor(id, name, orgPlan, initialCredit, seats, supportedLoginTypes, createdAt, featureFlags, salesforceAcctId, orgType, orgTimezone) {
        this.id = id;
        this.name = name;
        this.orgPlan = orgPlan;
        this.initialCredit = initialCredit;
        this.seats = seats;
        this.salesforceAcctId = salesforceAcctId;
        this.orgType = orgType;
        this.orgTimezone = orgTimezone;
        if (supportedLoginTypes)
            this.supportedLoginTypes = supportedLoginTypes;
        if (createdAt)
            this.createdAt = createdAt;
        this.featureFlags = featureFlags ?? [];
        JSON.validate(this, OrgInfo_1);
    }
    static validate(orgID, name) {
        new OrgInfo_1(orgID, name !== undefined ? name : 'valid name', OrgPlan.Enterprise, 1, 1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], OrgInfo.prototype, "createdAt", void 0);
OrgInfo = OrgInfo_1 = __decorate([
    JsonSchema(schema)
], OrgInfo);
export { OrgInfo };
//# sourceMappingURL=orgInfo.js.map